// Action Constants

export enum ActionConstant {
	GET_DETAILS = 'FILE://ORGANIZATION_MANAGEMENT/GET_DETAILS',
	GET_STATUS = 'FILE://ORGANIZATION_MANAGEMENT/GET_STATUS',
	CLEAR_DETAILS = 'FILE://ORGANIZATION_MANAGEMENT/CLEAR_DETAILS',
	CLEAR_STATUS = 'FILE://ORGANIZATION_MANAGEMENT/CLEAR_STATUS',
}

// State Types
export interface SubscriptionDetails {
	id: number;
	name: string;
	userId: number;
	planId: number;
	organizationId: number;
	paymentMethod: string;
	expiryDate: string;
	documentCount: number;
	documentSize: number;
	scanCount: number;
	projectCount: number;
	tradeCount: number;
	userCount: number;
	duration: number;
	durationUnit: number;
	amount: number;
	isActive: boolean;
	isDeleted: boolean;
	documentCountRemains: number;
	documentSizeRemains: number;
	scanCountRemains: number;
	projectCountRemains: number;
	tradeCountRemains: number;
	userCountRemains: number;
	documentCountTotal: number;
	documentSizeTotal: number;
	scanCountTotal: number;
	projectCountTotal: number;
	tradeCountTotal: number;
	userCountTotal: number;
}
export interface PlanDetails {
	id: number;
	name: string;
	documentCount: any;
	documentSize: any;
	scanCount: any;
	projectCount: any;
	tradeCount: any;
	userCount: any;
	duration: any;
	durationUnit: any;
	amount: any;
	createdBy: any;
	organizationId: any;
	isActive: true;
	isDeleted: false;
	packageKey: string;
	priceKey: string;
}
export interface Details {
	id: number;
	name: string;
	location: string;
	email: string;
	phone: string;
	primaryContact: string;
	isDeleted: boolean;
	createdBy: number;
	subscriptionId: number;
	enterprisePlanId: number;
	Plan: PlanDetails;
	Subscription: SubscriptionDetails;
}

// Action Types
export interface GetDetailsType {
	type: ActionConstant.GET_DETAILS;
	data: Details;
}
export interface GetStatusType {
	type: ActionConstant.GET_STATUS;
	status: number;
}
export interface ClearDetailsType {
	type: ActionConstant.CLEAR_DETAILS;
}
export interface ClearStatusType {
	type: ActionConstant.CLEAR_STATUS;
}
export type ActionType = GetDetailsType | GetStatusType | ClearDetailsType | ClearStatusType;

export interface InitialState {
	detailsFetching: boolean;
	details: Details;
	statusCode: number;
}
